import { Grid2 as Grid, Typography } from "@mui/material";
import { TextEditor } from "components/FormControls/TextEditor/TextEditor";
import { useMessage } from "hooks/intl";
import { RewardFields } from "types/rewards";
import { useStyles } from "../RewardForm.styles";

interface Props {
  index: number;
  translation: RewardFields["translations"][number];
  setFieldValue: (field: string, value: string) => void;
  isEditMode?: boolean;
}

export const TranslationFields = ({
  index,
  translation,
  setFieldValue,
  isEditMode,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const translationId = isEditMode ? translation?.locale : translation?.code;

  return (
    <>
      <Grid size={12}>
        <Typography className={classes.fieldName}>
          {`${message({
            id: "usageInstruction",
          })} (${translation?.languageName || translation?.code || translation?.locale})`}
        </Typography>
        <TextEditor
          key={`usage-${translationId}`}
          onChange={(val) =>
            setFieldValue(`translations[${index}].usageInstruction`, val)
          }
          value={translation?.usageInstruction}
          data-test-id={`reward-form-usage-instruction-${translationId}-input`}
        />
      </Grid>
      <Grid size={12}>
        <Typography className={classes.fieldName}>
          {`${message({
            id: "conditionsDescription",
          })} (${translation?.languageName || translation?.code || translation?.locale})`}
        </Typography>
        <TextEditor
          key={`conditions-${translationId}`}
          onChange={(val) =>
            setFieldValue(`translations[${index}].conditionsDescription`, val)
          }
          value={translation?.conditionsDescription}
          data-test-id={`reward-form-condition-description-${translationId}-input`}
        />
      </Grid>
      <Grid size={12}>
        <Typography className={classes.fieldName}>
          {`${message({
            id: "brandName",
          })} (${translation?.languageName || translation?.code || translation?.locale})`}
        </Typography>
        <TextEditor
          key={`brand-name-${translationId}`}
          onChange={(val) =>
            setFieldValue(`translations[${index}].brandName`, val)
          }
          value={translation?.brandName}
          data-test-id={`reward-form-brand-name-${translationId}-input`}
        />
      </Grid>
      <Grid size={12}>
        <Typography className={classes.fieldName}>
          {`${message({
            id: "brandDescription",
          })} (${translation?.languageName || translation?.code || translation?.locale})`}
        </Typography>
        <TextEditor
          key={`brand-description-${translationId}`}
          onChange={(val) =>
            setFieldValue(`translations[${index}].brandDescription`, val)
          }
          value={translation?.brandDescription}
          data-test-id={`reward-form-brand-description-${translationId}-input`}
        />
      </Grid>
    </>
  );
};
